import formatInTimeZone from 'date-fns-tz/formatInTimeZone';

export const generateFileName = (args: {
  productIds: string[],
  products: { id: string, abbreviation: string }[],
  regionIds: string[],
  regions: { id: string, abbreviation: string }[],
  period: string,
  sectorName?: string,
  industryName?: string,
  parentName?: string | null,
}): string => {
  const {
    productIds,
    products,
    regionIds,
    regions,
    period,
    sectorName,
    industryName,
    parentName,
  } = args;

  const fileName = [];

  let date = formatInTimeZone(new Date(), 'America/New_York', 'yyyy-MM-dd hhmm');
  let name = `Top ${ parentName ? 'Issuers' : 'Parents' }, Rating Agencies, Underwriters`;
  let productAbbreviation = [];
  let regionAbbreviation = [];

  // eslint-disable-next-line no-restricted-syntax
  for (let product of products) {
    productIds.forEach((id) => {
      if (id === product.id) {
        productAbbreviation.push(product.abbreviation);
      }
    });
  }

  // eslint-disable-next-line no-restricted-syntax
  for (let region of regions) {
    regionIds.forEach((id) => {
      if (id === region.id) {
        regionAbbreviation.push(region.abbreviation);
      }
    });
  }

  fileName.push(name);

  if (parentName) {
    fileName.push(parentName);
  }

  if (sectorName) {
    fileName.push(sectorName);
  }
  if (industryName) {
    fileName.push(industryName);
  }

  fileName.push(regionAbbreviation.join(','));
  fileName.push(productAbbreviation.join(','));
  fileName.push(period === 'TTM' ? 'past 12 months' : period);
  fileName.push(date);

  return fileName.join(' ');
};
